import { Card, CardContent, Typography } from '@material-ui/core'
import React from 'react'

interface IThemeItemProps {
    themeKey: string,
    theme: any,
    isSelected: boolean,
    onSelected: (key: string) => void
}

export default function ThemeItem({ themeKey, theme, isSelected, onSelected }: IThemeItemProps) {
    function handleClicked() {
        onSelected(themeKey)
    }

    const accent = theme.theme.palette.primary.main

    return (
        <Card
            onClick={handleClicked}
            style={{
                width: '100%',
                cursor: 'pointer',
                backgroundColor: theme.theme.overrides.MuiCssBaseline.bgColor,
                boxShadow: isSelected ? `0 0 0 2px ${accent}` : undefined,
            }}
        >
            <CardContent style={{ padding: 12 }}>
                <Typography variant="body2" style={{ color: theme.theme.palette.text.primary, marginBottom: 8 }}>
                    {theme.name}
                </Typography>
                <div style={{ backgroundColor: theme.theme.palette.primary.main, height: "8px", borderRadius: "4px" }} />
                <div style={{ backgroundColor: theme.theme.palette.secondary.main, height: "8px", borderRadius: "4px", marginTop: '4px' }} />
            </CardContent>
        </Card>
    )
}
